import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminShelfApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_SHELF);
  }

  /** 컬렉션 URL (끝 슬래시 1개 보장) */
  getCollectionUrl() {
    const base = String(this.getResourceUrl()).replace(/\/+$/, '');
    return `${base}/`;
  }

  /** FormData로 생성 (POST /shelves/) */
  createForm(formData) {
    const url = this.getCollectionUrl();
    return this.httpClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  /** JSON 바디로 생성이 필요할 때 */
  create(data) {
    const url = this.getCollectionUrl();
    return this.httpClient.post(url, data);
  }

  transfer(data) {
    const url = `${this.getCollectionUrl()}transfer/`;
    return this.httpClient.post(url, data);
  }

  /** 단일 ProductBatch를 다른 선반으로 이동 (동일 스펙 batch가 있으면 합산) */
  batchTransfer(data) {
    const url = `${this.getCollectionUrl()}batch-transfer/`;
    return this.httpClient.post(url, data);
  }

  exportShelf(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }
}

export default new AdminShelfApi();
